<template>
  <div id="nativeShare">
    <div class="label share-title">请选择分享平台</div>
    <div class="list">
      <span class="list-item" v-for="(button, index) in shareButtons" :key="index">
        <img :src="button.src" class="i" @click="call(button)" />
        {{button.text}}
      </span>
      <button v-if="fzljLink" class="list-item" @click="showPopup" v-clipboard:copy="fzljLink"> <img :src="fzljIcon" class="i" />
        复制链接</button>
    </div>
  </div>
</template>

<script>
import { Toast } from "vant";
import { getshareparams } from "../../api/api";
import NativeShare from "nativeshare";
import mShare from "m-share";
export default {
  name: "vue-share-native",
  data () {
    return {
      Buttons: [
        {
          text: "微信好友",
          nativeshare: "wechatFriend",
          m_share: "wx",
          src: require("../../assets/images/weixin.png")
        },
        {
          text: "朋友圈",
          nativeshare: "wechatTimeline",
          m_share: "wxline",
          src: require("../../assets/images/wxfriend.png")
        },
        {
          text: "QQ好友",
          nativeshare: "qqFriend",
          m_share: "qq",
          src: require("../../assets/images/qq.png")
        },
        {
          text: "QQ空间",
          nativeshare: "qZone",
          m_share: "qzone",
          src: require("../../assets/images/qqzone.png")
        },
        {
          text: "新浪微博",
          nativeshare: "weibo",
          m_share: "sina",
          src: require("../../assets/images/weibo.png")
        },
        {
          text: "更多",
          nativeshare: "",
          m_share: "",
          src: require("../../assets/images/more.png")
        }
      ],
      wechatConfig: {},
      fzljIcon: require("../../assets/images/circle_icon_fzlj.png")
    };
  },
  props: {
    config: Object,
    shareMenu: Array,
    fzljLink: String
  },
  computed: {
    shareButtons () {
      if (!this.shareMenu) {
        return this.Buttons;
      }
      return this.shareMenu
        .map(i => this.Buttons[i])
        .filter(i => i !== undefined);
    }
  },
  created () {
    let that = this;

    getshareparams({ url: that.config.url })
      .then(res => {
        if (res.data.code == 200) {
          let wechatConfig = {
            appId: res.data.data.appId,
            timestamp: res.data.data.timestamp,
            nonceStr: res.data.data.nonceStr,
            signature: res.data.data.signature
          };
          that.wechatConfig = wechatConfig;
        }
      })
      .catch(err => { });
  },
  methods: {
    showPopup () {
      Toast.success({
        duration: 2000,
        message: "链接已复制，快去分享吧！"
      });
    },
    call (command) {
      let shareData = {
        //nativeShare的参数模型
        title: this.config.title,
        desc: this.config.desc,
        // 如果是微信该link的域名必须要在微信后台配置的安全域名之内的。
        link: this.config.link,
        icon: this.config.img,
        // 不要过于依赖以下两个回调，很多浏览器是不支持的
        success: this.config.success,
        fail: this.config.cancel
      };
      let mShareData = {
        //m-share的参数模型
        title: this.config.title, // 标题，默认读取document.title
        desc: this.config.desc, // 描述, 默认读取head标签：<meta name="description" content="desc" />
        link: this.config.link, // 网址，默认使用window.location.href
        imgUrl: this.config.img, // 图片, 默认取网页中第一个img标签
        fnDoShare: this.config.success
      };

      let nativeShare = new NativeShare();

      nativeShare.setShareData(shareData);

      nativeShare.setConfig({
        wechatConfig: this.wechatConfig
      });

      //判断是否为微信，单独处理
      /*   if (/micromessenger/i.test(navigator.userAgent)) {
          mShare.to(command.m_share, mShareData);
        } else {
         
        } */
      try {
        nativeShare.call(command.nativeshare);
      } catch (e) {
        console.log("调用失败");
        //iphone的qq浏览器调用此api
        //除iphone的qq浏览器外其他浏览器调用的api
        //在iphone的qq浏览器中比较奇葩，第一次调用nativeShare.call()会报错，第二次之后不报，这里是让每次调用nativeShare.call()之后都报错，然后统一去调m-share.to()方法
        mShare.to(command.m_share, mShareData);
      }
    }
  }
};
</script>

<style scoped>
#nativeShare {
  font-size: 13px;
}
.label {
  font-size: 18px;
  text-align: center;
  padding-bottom: 0.5rem;
}
.list {
  text-align: center;
}
.list-item {
  width: 33.3%;
  display: inline-block;
  margin: 10px 0;
  float: left;
  border: 0;
  background: none;
}
.i {
  width: 40px;
  height: 40px;
  display: block;
  margin: 0 auto;
  margin-bottom: 5px;
  background-size: cover;
}
.share-title {
  padding: 1rem;
}
</style>


// WEBPACK FOOTER //
// src/components/plugins/vue-native-share.vue